import script from "./Report_Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Report_Table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__